import { Component, inject, signal } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { LoadingService } from '../../../../services/loading.service';
import { UserService } from '../../../../services/user.service';
import { ThemeService } from '../../../../services/theme.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { CustomMessages, CustomResponse } from '../../../../interfaces/custom-response.model';
import { Router } from '@angular/router';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';


@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [ToastModule, DividerModule, PanelModule, DropdownModule, ButtonModule, FormsModule, ReactiveFormsModule, InputTextModule, PasswordModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.css',
  providers: [MessageService]
})
export class UserProfileComponent {

  loadingService = inject(LoadingService);
  userService = inject(UserService);
  themeService = inject(ThemeService);
  messageService = inject(MessageService);
  fb = inject(FormBuilder);
  router = inject(Router);

  loading: boolean = false;
  username: string = "";

  selectedTheme: string = "";
  currentBranch: number = 0;

  themes: any = {}

  passwordForm = this.fb.group({
    password: ['', Validators.required],
    password_confirmation: ['', Validators.required]
  });

  errorMessages: CustomMessages = {};

  async ngOnInit(): Promise<void> {

    this.selectedTheme = localStorage.getItem("defaultTheme") ?? "";
    this.themes = this.themeService.getThemes();


  }

  changeLocation($event: any) {
    console.log(this.currentBranch);
    this.userService.updateStandardNiederlassung(this.currentBranch, localStorage.getItem("userid") ?? "").subscribe(response => {
      if (response.success == 1) {
        this.messageService.add({ key: 'tc', severity: 'success', summary: response.message });
      }
      else {
        this.messageService.add({ key: 'tc', severity: 'error', summary: 'Fehler', detail: response.message });
      }
    });
  }

  previewTheme() {
    this.themeService.previewTheme(this.selectedTheme);
  }

  setTheme() {
    this.themeService.switchTheme(this.selectedTheme);
    this.loadingService.addCounter();

    this.userService.updateTheme(localStorage.getItem("userid") ?? "", this.selectedTheme).subscribe(data => this.handleResponse(data));

  }

  handleResponse(response: CustomResponse) {
    if (response.success = 1) {
      this.messageService.add({ key: 'tc', severity: 'success', summary: "Das ausgewählte Theme wurde gespeichert!" });
    }
    else {
      this.messageService.add({ key: 'tc', severity: 'error', summary: 'Fehler', detail: response.message });
    }
    this.loadingService.reset();
  }

  savePassword() {
    console.log(this.passwordForm.value)

    if (this.passwordForm.valid) {
      this.loadingService.addCounter();

      this.userService.changePassword(localStorage.getItem("userid") ?? "", this.passwordForm.value).subscribe({
        next: (data) => {
          if (data.success == 1) {
            this.messageService.add({ key: 'tc', severity: 'success', summary: data.message });
          }
          else {
            this.messageService.add({ key: 'tc', severity: 'error', summary: data.message });
            this.errorMessages = data.messages ?? {};
          }

          // this.loading = false;
          this.loadingService.removeCounter();
        },
        error: (error) => {
          if (error.status == 401) {
            console.log("Fehler! Auf zum Login!")
            this.loadingService.removeCounter();
            this.router.navigateByUrl("/logout");
          }
        }
      }
      );
    }
  }


}
